<template>
    <div class="form__group">
        <div class="color-picker"
             v-bind:class="{ 'is-right' : position == 'right', 'is-left' : position == 'left' }"
             v-on-clickaway="closePicker"
        >
            <label class="color-picker__label">{{ label }}</label>
            <div class="color-picker__preview" v-bind:style="backgroundColorProperty" v-on:click="togglePicker"></div>

            <div class="color-picker__picker" v-bind:class="{ 'is-active' : isActive }">
                <chrome-picker v-model="color" />
                <input type="hidden" v-bind:value="value" />
            </div>
        </div>
    </div>
</template>

<script>
    import { Chrome } from 'vue-color';

    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        components: {
            'chrome-picker': Chrome
        },
        computed: {
            backgroundColorProperty: function () {
                return 'background-color: ' + this.color.hex + ';';
            }
        },
        data: function () {
            return {
                color: this.value,
                isActive: false
            }
        },
        methods: {
            closePicker: function () {
                this.isActive = false;
            },
            togglePicker: function () {
                this.isActive = !this.isActive;
            }
        },
        mixins: [
            clickaway
        ],
        props: {
            label: {
                required: true,
                type: String
            },
            position: {
                default: 'right',
                type: String
            },
            value: {
                default: {
                    hex: '#ffffff',
                    hsl: { h: 0, s: 0, l: 1, a: 1 },
                    hsv: { h: 0, s: 0, v: 1, a: 1 },
                    rgba: { r: 255, g: 255, b: 255, a: 1 },
                    a: 1
                },
                type: Object
            }
        },
        watch: {
            color: function (value) {
                this.$emit('input', value);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/elements/ColorPicker.vue